import { DropdownMenuItem } from "@radix-ui/react-dropdown-menu";
import { DropdownMenu as UiDropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "../ui/dropdownMenu";
import Button from "../Button";
import { ChevronDown } from "lucide-react";
import { twMerge } from "tailwind-merge";
import React from "react";

interface DropdownMenuProps {
  triggerLabel: string;
  triggerClassName?: string;
  contentClassName?: string;
  itemClassName?: string;
  dataTestId?: string;
  options: {
    label: string;
    onClick: () => void;
    className?: string;
    disabled?: boolean;
    operationKlassToCheckPermission?: string;
    tooltipMessage?: string;
    dataTestId?: string;
  }[];
  disabled?: boolean;
  operationKlassToCheckPermission?: string;
  menuPosition?: "top" | "right" | "bottom" | "left";
  menuPositionAlign?: "start" | "center" | "end";
}

const DropdownMenu = ({
  triggerLabel,
  triggerClassName,
  contentClassName,
  itemClassName,
  dataTestId,
  options,
  disabled,
  operationKlassToCheckPermission,
  menuPosition,
  menuPositionAlign,
}: DropdownMenuProps) => {
  const uniqueId = React.useId()

  return (
    <UiDropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button
          dataTestId={dataTestId || "dropdown_menu_trigger"}
          className={triggerClassName}
          operationKlassToCheckPermission={disabled ? 'show-tooltip' : operationKlassToCheckPermission}
          disabled={disabled}
        >
          {triggerLabel}

          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={twMerge('bg-black-900 border-none rounded-sm shadow-[0px_0px_8px_4px_rgba(0,_0,_0,_0.2)]', contentClassName)}
        align={menuPositionAlign}
        side={menuPosition}
      >
        {options.map((option, index) => (
          <DropdownMenuItem
            key={`dropdown-menu-item-${uniqueId}-${index}`}
            className={twMerge(
              "hover:bg-white-100 hover:outline-none cursor-pointer",
              itemClassName,
              option.disabled && 'cursor-default text-white-300 hover:bg-transparent',
              option.className
            )}
            disabled={option.disabled}
          >
            <Button
              variant="link-white"
              className="text-white-800 font-normal text-sm px-3 py-2 w-full justify-start"
              operationKlassToCheckPermission={option.operationKlassToCheckPermission}
              disabled={option.disabled}
              tooltipMessage={option.tooltipMessage}
              onClick={() => !option.disabled && option.onClick()}
              dataTestId={option.dataTestId}
            >
              {option.label}
            </Button>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </UiDropdownMenu>
  );
};

export default DropdownMenu;
